import { render, staticRenderFns } from "./RevenueInformation.vue?vue&type=template&id=22712557&lang=pug&"
import script from "./RevenueInformation.vue?vue&type=script&lang=ts&"
export * from "./RevenueInformation.vue?vue&type=script&lang=ts&"
import style0 from "./RevenueInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports